// @flow
import React from 'react'
import TextWithNewlines from '../../TextWithNewlines'
import styled, { type StyledComponent } from 'styled-components'
import logo from '../images/fb-promo-logo.png'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Media, Crop, Public } from '../../types'
import { translateFunc, translations } from '../../../shared/localize'
import _ from 'lodash'

import commentIcon from '../images/facebook-comment.png'
import headlikeIcon from '../images/facebook-headlike.png'
import likeIcon from '../images/facebook-like.png'
import planetIcon from '../images/facebook-planet.png'
import shareIcon from '../images/facebook-share.png'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 502px;
  background-color: #ffffff;
  border: 1px solid;
  border-color: #e5e6e9 #dfe0e4 #d0d1d5;
  border-radius: 3px;
  font: 12px/16px Helvetica, Arial, Lucida Grande, sans-serif;
`
const Heading: StyledComponent<Object, any, any> = styled.div`
  padding: 12px;

  &:after {
    content: '';
    display: table;
    clear: both;
  }
`
const HeadingSidebar: StyledComponent<Object, any, any> = styled.div`
  float: right;
  padding-left: 22px;
`
const HeadingLogo: StyledComponent<Object, any, any> = styled.div`
  float: left;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
  background: url(${({ url }: Object) => url || logo}) no-repeat;
  background-size: cover;
  border-radius: 50%;
`
const HeadingInfo: StyledComponent<Object, any, any> = styled.div`
  padding-left: 8px;
  padding-top: 1px;
  overflow: hidden;
`
const HeadingTitle: StyledComponent<Object, any, any> = styled.div`
  color: #365899;
  font: bold 14px/19px Helvetica, Arial, Lucida Grande, sans-serif;
`
const Button: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  padding: 0 8px;
  background-color: #f6f7f9;
  border: 1px solid #ced0d4;
  border-radius: 2px;
  color: #4b4f56;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  text-decoration: none;
`
const Icon: StyledComponent<Object, any, any> = styled.span`
  display: inline-block;
  vertical-align: middle;
`
const IconLike: StyledComponent<Object, any, any> = styled(Icon)`
  position: relative;
  bottom: 1px;
  width: 13px;
  height: 14px;
  background: url(${headlikeIcon}) no-repeat;
  background-size: cover;
`
const IconGlobe: StyledComponent<Object, any, any> = styled(Icon)`
  margin-left: 3px;
  background: url(${planetIcon}) no-repeat;
  background-size: cover;
  width: 10px;
  height: 10px;
`
const Promotion: StyledComponent<Object, any, any> = styled.span`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding-right: 10px;
  color: #616770;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 2px;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: #90949c;
  }
`
const Container: StyledComponent<Object, any, any> = styled.div``
const Footer: StyledComponent<Object, any, any> = styled.div`
  margin-top: 8px;
`
const FooterCanvas: StyledComponent<Object, any, any> = styled.div`
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.098) rgba(0, 0, 0, 0.149) rgba(0, 0, 0, 0.231);
`
const FooterInfo: StyledComponent<Object, any, any> = styled.div`
  position: relative;
  padding: 8px 12px;
  border: 1px solid;
  border-color: transparent #e9ebee #d1d1d1;
  background-color: #f2f2f2;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  font: 500 18px/22px Georgia, serif;
  color: #1d2129;
  width: 390px;
`
const Subtitle: StyledComponent<Object, any, any> = styled.div`
  letter-spacing: 0.3px;
  padding: 0 12px;
  font-size: 14px;
`
const DomainURL: StyledComponent<Object, any, any> = styled.div`
  text-transform: uppercase;
  display: inline-block;
  margin-bottom: 2px;
  color: #606770;
  font-size: 12px;
`
const ActionButtonWrapper = styled.div`
  flex-grow: 1;
`
const LikeIcon = styled.div`
  background: url(${likeIcon}) no-repeat center center;
  background-size: cover;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  margin-bottom: 3px;
`
const CommentIcon: StyledComponent<Object, any, any> = styled.div`
  background: url(${commentIcon}) no-repeat center center;
  background-size: cover;
  width: 18px;
  height: 18px;
  margin-right: 5px;
`
const ShareIcon: StyledComponent<Object, any, any> = styled.div`
  background: url(${shareIcon}) no-repeat center center;
  background-size: cover;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  margin-bottom: 2px;
`

const ActionButton: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;
  color: #616770;
  margin-right: 5px;
  border: none;
  background: none;
  font-size: 13px;

  &:last-of-type {
    margin-right: 0;
  }

  * {
    cursor: pointer;
  }
`
const MoreButton: StyledComponent<Object, any, any> = styled.button`
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #eff1f3;
  border: 1px solid rgb(190, 194, 201);
  border-radius: 2px;
  padding-left: 10px;
  padding-right: 10px;
  height: 26px;
`
const BottomButtons: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  height: 40;
  padding: 4px 12px;
`

type Props = {|
  title: string,
  description: string,
  image: ?Media,
  imageCrop: ?Crop,
  publicInfo: Public,
  url: string,
  linkButton: string
|}

const t = translateFunc(translations.provider_previews.facebook)

export default function MultiFacebookPreview(props: Props) {
  const { title, description, image, imageCrop, publicInfo, url, linkButton } = props

  return (
    <Wrapper>
      <Heading>
        <HeadingSidebar>
          <Button>
            <IconLike /> Нравится Страница
          </Button>
        </HeadingSidebar>
        <div>
          <HeadingLogo url={publicInfo && publicInfo.image_url} />
          <HeadingInfo>
            <HeadingTitle>
              {_.isEmpty(publicInfo) ? 'Название группы' : publicInfo.label}
            </HeadingTitle>
            <div>
              <Promotion>Реклама</Promotion>
              <IconGlobe />
            </div>
          </HeadingInfo>
        </div>
      </Heading>
      <Container>
        <Subtitle>
          <TextWithNewlines value={description} />
        </Subtitle>
        <Footer>
          <FooterCanvas>
            <OptionalResponsibleImage
              image={image}
              imageCrop={imageCrop}
              width={500}
              ratio={1.91}
              block
            />
          </FooterCanvas>
          <FooterInfo>
            <DomainURL>{url}</DomainURL>
            <Title>{title}</Title>
            <MoreButton>{t(linkButton)}</MoreButton>
          </FooterInfo>
        </Footer>
        <BottomButtons>
          <ActionButtonWrapper>
            <ActionButton>
              <LikeIcon />
              <span>Нравится</span>
            </ActionButton>
          </ActionButtonWrapper>
          <ActionButtonWrapper>
            <ActionButton>
              <CommentIcon />
              <span>Комментарий</span>
            </ActionButton>
          </ActionButtonWrapper>
          <ActionButtonWrapper>
            <ActionButton>
              <ShareIcon />
              <span>Поделиться</span>
            </ActionButton>
          </ActionButtonWrapper>
        </BottomButtons>
      </Container>
    </Wrapper>
  )
}
